import React from 'react';

const NoPodcastIcon = () => (
  <svg viewBox="0 0 30 30">
    <title>{'Atom / Icon / Navigation / No_podcasts'}</title>
    <path
      d="M3.854 3.146l23 23a.502.502 0 01-.708.708l-23-23a.502.502 0 01.708-.708zM7.5 15a.5.5 0 01.5.5c0 3.032 2.467 5.5 5.5 5.5a5.482 5.482 0 003.824-1.555l.702.702A6.48 6.48 0 0114 21.975V24h2.5a.5.5 0 010 1h-6a.5.5 0 010-1H13v-2.025c-3.351-.257-6-3.06-6-6.475a.5.5 0 01.5-.5zM9 11.121l1 1v3.38c0 1.928 1.57 3.5 3.5 3.5.933 0 1.78-.374 2.407-.973l.707.707A4.48 4.48 0 0113.5 20 4.505 4.505 0 019 15.5v-4.379zM19.5 15a.5.5 0 01.5.5c0 .715-.122 1.399-.336 2.043l-.809-.809c.092-.397.145-.809.145-1.234a.5.5 0 01.5-.5zm-2.246-7.936a.502.502 0 01.504.007l5 3a.501.501 0 010 .858l-5 3a.51.51 0 01-.504.006A.501.501 0 0117 13.5v-6c0-.18.097-.346.254-.436zM18 8.384v4.233l3.528-2.117L18 8.383zM13.5 3c1.602 0 3.094.86 3.896 2.248a.501.501 0 01-.181.684.503.503 0 01-.684-.183 3.512 3.512 0 00-3.031-1.75C11.57 4 10 5.57 10 7.5v.38l-.943-.943C9.338 4.723 11.212 3 13.5 3z"
      fill="#8D929E"
      fillRule="nonzero"
    />
  </svg>
);

export default NoPodcastIcon;
